import { CommunicatorUIState } from './ui.interfaces';

export const initialUIState: CommunicatorUIState = {
  sidenavVisible: false,
};
